var e=["google"],o="parsed-resume-content";export{o as PARSED_RESUME_STORAGE_KEY,e as REFERRERS_TO_SKIP_RESUME_PARSING};
//# sourceMappingURL=index.js.map
